import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './style.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const settings = {
	dots: true,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 5000
};

const Testimoni: React.FC = () => {
	const [testimonials, setTestimonials] = useState<any[]>([]);
	const emojiList = ['🔥', '👍', '👋', '💬', '⭐', '🫰', '🚙'];

	useEffect(() => {
		const loadData = async () => {
			const response = await import('./testimoni.json');
			setTestimonials(response.default);
		};

		loadData();
	}, []);

	React.useEffect(() => {
		if (testimonials.length > 0) {
			const script = document.createElement('script');
			script.type = 'application/ld+json';
			script.innerHTML = JSON.stringify({
				'@context': 'https://schema.org',
				'@type': 'Service',
				name: 'Rental Hiace Bandung - Sewa Hiace	 Murah & Cepat | Ketaren Transport',
				aggregateRating: {
					'@type': 'AggregateRating',
					ratingValue: (
						testimonials.reduce((sum, testimoni) => sum + 5, 0) / testimonials.length
					).toFixed(1),
					reviewCount: testimonials.length
				},
				mainEntityOfPage: {
					'@type': 'WebPage',
					'@id': window.location.href
				},
				review: testimonials.map(testimoni => ({
					'@type': 'Review',
					itemReviewed: {
						'@type': 'Service',
						name: 'Rental Hiace Bandung - Sewa Hiace Murah & Cepat | Ketaren Transport'
					},
					author: {
						'@type': 'Person',
						name: testimoni.name
					},
					reviewBody: testimoni.text,
					datePublished: new Date().toISOString(),
					reviewRating: {
						'@type': 'Rating',
						ratingValue: (Math.random() * (5 - 4.5) + 4.5).toFixed(1),
						bestRating: 5
					}
				}))
			});
			document.head.appendChild(script);
		}
	}, [testimonials]);

	return (
		<motion.section
			className="page-content__inner testimoni-container"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: false, amount: 0.25 }}
			transition={{ duration: 0.5, ease: 'easeOut' }}
		>
			<div className="testimoni-list">
				{testimonials.map((testimoni, index) => {
					const randomEmoji = emojiList[Math.floor(Math.random() * emojiList.length)];
					return (
						<motion.div
							key={index}
							className="testimoni-item"
							whileHover={{
								scale: 1.05,
								y: -5
							}}
							transition={{
								type: 'spring',
								stiffness: 400,
								damping: 10
							}}
							onClick={() => {
								const modal = document.createElement('div');
								modal.className = 'testimoni-modal';
								modal.style.position = 'fixed';
								modal.style.top = '0';
								modal.style.left = '0';
								modal.style.width = '100%';
								modal.style.height = '100%';
								modal.innerHTML = `
								<div class="modal-content">
									<h3>${randomEmoji}${testimoni.name}${randomEmoji}</h3>
									<p>${testimoni.text}</p>
									<button>Tutup</button>
								</div>
							`;

								modal.addEventListener('click', e => {
									if (e.target === modal) {
										modal.remove();
									}
								});

								const closeButton = modal.querySelector('button');
								if (closeButton) {
									closeButton.addEventListener('click', () => {
										modal.remove();
									});
								}

								document.body.appendChild(modal);
							}}
						>
							<h5>
								{randomEmoji}
								{testimoni.name}
								{randomEmoji}
							</h5>
							<p>{testimoni.text.slice(0, 100)}...</p>
						</motion.div>
					);
				})}
			</div>
			<h2 className="mobile-testimoni-title">Testimoni Customer</h2>
			<motion.section
				className="mobile-testimoni"
				initial={{ opacity: 0, y: 50 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, ease: 'easeOut' }}
			>
				<Slider {...settings}>
					{testimonials.map((testimoni, index) => {
						const randomEmoji = emojiList[Math.floor(Math.random() * emojiList.length)];
						return (
							<div key={index} className="testimoni-item">
								<h5>
									{randomEmoji}
									{testimoni.name}
									{randomEmoji}
								</h5>
								<p>{testimoni.text}</p>
							</div>
						);
					})}
				</Slider>
			</motion.section>
		</motion.section>
	);
};

export default Testimoni;
